import { DelegationChain, DelegationIdentity } from "@dfinity/identity";
import { SignIdentity } from "@dfinity/agent";
export function buildDelegationIdentity(userKey, sessionKey, delegation, signature) {
    const delegations = [
        {
            delegation,
            signature,
        },
    ];
    const delegationChain = DelegationChain.fromDelegations(delegations, userKey);
    return DelegationIdentity.fromDelegation(sessionKey, delegationChain);
}
export function toDer(key) {
    return key.getPublicKey().toDer();
}
